import {
	HttpEvent,
	HttpHandler,
	HttpInterceptor,
	HttpRequest
} from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { SignalRService } from 'src/app/services/signalr/signalr.service';

@Injectable()
export class SignalRInterceptor implements HttpInterceptor {
	private signalRService = inject(SignalRService);

	intercept(
		request: HttpRequest<any>,
		next: HttpHandler
	): Observable<HttpEvent<any>> {
		return next
			.handle(request)
			.pipe(
				finalize(() => void this.signalRService.dataChanged(request))
			);
	}
}
